import { sameArticle } from './aisles';

/**
 * Common shopping articles for suggestions while typing (1.20, Mike: "Autocomplete … eine Auswahl,
 * die man nur noch anklicken muss"). The family's own articles always come first; this list
 * helps a family whose list is still new.
 */
export const ARTICLES: Record<'de' | 'en', string[]> = {
  de: [
    'Äpfel',
    'Ananas',
    'Auberginen',
    'Avocado',
    'Bananen',
    'Birnen',
    'Blumenkohl',
    'Brokkoli',
    'Champignons',
    'Cherrytomaten',
    'Erdbeeren',
    'Frühlingszwiebeln',
    'Gurke',
    'Heidelbeeren',
    'Ingwer',
    'Karotten',
    'Kartoffeln',
    'Kiwis',
    'Knoblauch',
    'Kohlrabi',
    'Kürbis',
    'Lauch',
    'Mais',
    'Mandarinen',
    'Mango',
    'Möhren',
    'Orangen',
    'Paprika',
    'Petersilie',
    'Basilikum',
    'Radieschen',
    'Salat',
    'Spinat',
    'Süßkartoffeln',
    'Tomaten',
    'Trauben',
    'Zitronen',
    'Zucchini',
    'Zwiebeln',
    'Brot',
    'Brötchen',
    'Toast',
    'Vollkornbrot',
    'Baguette',
    'Croissants',
    'Wraps',
    'Knäckebrot',
    'Milch',
    'Hafermilch',
    'Butter',
    'Eier',
    'Joghurt',
    'Quark',
    'Sahne',
    'Schmand',
    'Frischkäse',
    'Käse',
    'Gouda',
    'Mozzarella',
    'Parmesan',
    'Feta',
    'Schinken',
    'Salami',
    'Aufschnitt',
    'Würstchen',
    'Tofu',
    'Hummus',
    'Pudding',
    'Hackfleisch',
    'Hähnchenbrust',
    'Schnitzel',
    'Bratwurst',
    'Lachs',
    'Speck',
    'Spaghetti',
    'Nudeln',
    'Penne',
    'Reis',
    'Couscous',
    'Linsen',
    'Passierte Tomaten',
    'Tomatenmark',
    'Kidneybohnen',
    'Thunfisch',
    'Ketchup',
    'Senf',
    'Mayonnaise',
    'Olivenöl',
    'Rapsöl',
    'Essig',
    'Gemüsebrühe',
    'Müsli',
    'Haferflocken',
    'Cornflakes',
    'Marmelade',
    'Honig',
    'Nutella',
    'Erdnussbutter',
    'Kaffee',
    'Tee',
    'Kakao',
    'Nüsse',
    'Mehl',
    'Zucker',
    'Backpulver',
    'Hefe',
    'Vanillezucker',
    'Salz',
    'Pfeffer',
    'Zimt',
    'Tiefkühlpizza',
    'Pommes',
    'Fischstäbchen',
    'Erbsen',
    'Eis',
    'Schokolade',
    'Chips',
    'Kekse',
    'Gummibärchen',
    'Salzstangen',
    'Müsliriegel',
    'Wasser',
    'Mineralwasser',
    'Apfelsaft',
    'Orangensaft',
    'Saft',
    'Cola',
    'Bier',
    'Wein',
    'Klopapier',
    'Küchenrolle',
    'Taschentücher',
    'Spülmittel',
    'Spülmaschinentabs',
    'Waschmittel',
    'Zahnpasta',
    'Zahnbürste',
    'Shampoo',
    'Duschgel',
    'Seife',
    'Deo',
    'Windeln',
    'Feuchttücher',
    'Müllbeutel',
    'Alufolie',
    'Backpapier',
    'Frischhaltefolie',
    'Batterien',
    'Sonnencreme',
    'Pflaster',
  ],
  en: [
    'Apples',
    'Avocados',
    'Bananas',
    'Basil',
    'Blueberries',
    'Broccoli',
    'Carrots',
    'Cauliflower',
    'Cherry tomatoes',
    'Courgettes',
    'Cucumber',
    'Garlic',
    'Ginger',
    'Grapes',
    'Leeks',
    'Lemons',
    'Lettuce',
    'Limes',
    'Mangoes',
    'Mushrooms',
    'Onions',
    'Oranges',
    'Parsley',
    'Pears',
    'Peppers',
    'Potatoes',
    'Spinach',
    'Spring onions',
    'Strawberries',
    'Sweet potatoes',
    'Tomatoes',
    'Bread',
    'Bagels',
    'Baguette',
    'Croissants',
    'Rolls',
    'Wholemeal bread',
    'Wraps',
    'Milk',
    'Oat milk',
    'Butter',
    'Eggs',
    'Yoghurt',
    'Cream',
    'Cream cheese',
    'Cheese',
    'Cheddar',
    'Mozzarella',
    'Parmesan',
    'Feta',
    'Ham',
    'Sausages',
    'Bacon',
    'Tofu',
    'Hummus',
    'Mince',
    'Chicken breast',
    'Salmon',
    'Spaghetti',
    'Pasta',
    'Rice',
    'Couscous',
    'Lentils',
    'Chopped tomatoes',
    'Passata',
    'Baked beans',
    'Tuna',
    'Ketchup',
    'Mustard',
    'Mayonnaise',
    'Olive oil',
    'Vinegar',
    'Stock cubes',
    'Cereal',
    'Porridge oats',
    'Muesli',
    'Jam',
    'Honey',
    'Peanut butter',
    'Coffee',
    'Tea',
    'Cocoa',
    'Nuts',
    'Flour',
    'Sugar',
    'Baking powder',
    'Yeast',
    'Salt',
    'Black pepper',
    'Cinnamon',
    'Frozen pizza',
    'Chips',
    'Fish fingers',
    'Frozen peas',
    'Ice cream',
    'Chocolate',
    'Crisps',
    'Biscuits',
    'Sweets',
    'Cereal bars',
    'Water',
    'Sparkling water',
    'Apple juice',
    'Orange juice',
    'Squash',
    'Beer',
    'Wine',
    'Toilet roll',
    'Kitchen roll',
    'Tissues',
    'Washing-up liquid',
    'Dishwasher tablets',
    'Laundry detergent',
    'Toothpaste',
    'Toothbrush',
    'Shampoo',
    'Shower gel',
    'Soap',
    'Deodorant',
    'Nappies',
    'Wipes',
    'Bin bags',
    'Foil',
    'Baking paper',
    'Cling film',
    'Batteries',
    'Sun cream',
    'Plasters',
  ],
};

export interface KnownArticle {
  name: string;
  /** How often the family bought it (ticked it off). */
  count?: number;
  /** Already on the list (open) – not suggested again. */
  open?: boolean;
}

const norm = (s: string) => s.toLowerCase().trim();

/**
 * What to offer while someone types: the family's own articles first (often bought first), then
 * common ones; a match at the start of the name or of a word beats one inside a word. Pure and
 * cheap – a few hundred strings, run on every keystroke.
 */
export function suggestArticles(
  query: string,
  own: KnownArticle[],
  common: string[],
  limit = 6,
): string[] {
  const q = norm(query);
  if (!q) return [];
  const scored: { name: string; score: number }[] = [];
  const place = (name: string) => {
    const n = norm(name);
    if (n.startsWith(q)) return 3;
    if (n.split(/[\s-]+/).some((w) => w.startsWith(q))) return 2;
    if (q.length >= 3 && n.includes(q)) return 1;
    return 0;
  };
  for (const a of own) {
    const p = place(a.name);
    if (p) scored.push({ name: a.name, score: p * 1000 + 500 + Math.min(a.count ?? 0, 499) });
  }
  for (const name of common) {
    const p = place(name);
    if (p) scored.push({ name, score: p * 1000 });
  }
  scored.sort((a, b) => b.score - a.score || a.name.localeCompare(b.name));
  const out: string[] = [];
  for (const s of scored) {
    // never twice ("Tomaten" from the family and from the list), never what is already open
    if (out.some((o) => sameArticle(o, s.name))) continue;
    if (own.some((a) => a.open && sameArticle(a.name, s.name))) continue;
    if (norm(s.name) === q && own.some((a) => a.open && norm(a.name) === q)) continue;
    out.push(s.name);
    if (out.length >= limit) break;
  }
  return out;
}
